<template>
    <transition name="hideModal" @after-enter="onWrapperAfterEnter" @after-leave="onLayerClose">
        <div class="modal-wrap" v-if="wrapperVisible">
            <transition name="scale" @after-leave="onChildAfterLeave">
                <div class="modal-body" v-if="bodyVisible">
                    <slot/>
                </div>
            </transition>
        </div>
    </transition>
</template>

<script lang="ts" setup>
    import { nextTick, ref, watch } from 'vue';
    const emits = defineEmits(["handleCloseOver"]);
    let props = defineProps({
        visible: {
            type: Boolean,
            default: false,
        },
    });
    let wrapperVisible = ref(false);
    let bodyVisible = ref(false);
    watch(
        () => props.visible,
        (newValue: boolean, oldValue: boolean) => {
            if (newValue) {
                wrapperVisible.value = true;
                nextTick(() => {
                    bodyVisible.value = true;
                });
            } else {
                bodyVisible.value = false;
            }
        }
    );
    function onChildAfterLeave() {
        wrapperVisible.value = false;
    }

    function onWrapperAfterEnter() {
        bodyVisible.value = true;
    }

    function onLayerClose() {
        emits('handleCloseOver');
    }
</script>

<style lang="less" scoped>
.modal-wrap {
    position: fixed;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1005;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    
    .modal-body{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.hideModal-leave-active {
    transition: opacity 0.1s ease;
}

.hideModal-leave-to{
    opacity: 0;
}
</style>